import React from 'react';

/**
 * FlowBar — the signature brand gradient bar (PHASE-1.5-BRAND-SPEC.md §2).
 * DraftFlow's second stop is blue #3B82F6 — that IS the sibling signature
 * (CRAI's bar runs teal→cyan→violet→gold). Do not "correct" it to cyan.
 * No border-radius, no shadow, no animation.
 * Placements (nowhere else): app shell top edge, app footer bottom edge (4px);
 * landing hero top, landing page bottom (8px).
 */
export const FlowBar = ({ height = 4 }) => (
  <div
    aria-hidden="true"
    data-testid="flow-bar"
    style={{
      height: `${height}px`,
      width: '100%',
      background: 'linear-gradient(90deg, #2DD4BF 0%, #3B82F6 33%, #A78BFA 66%, #C6952B 100%)',
      flexShrink: 0,
    }}
  />
);

export default FlowBar;
